import React from "react";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import BoxInc from "../../../shared-ui/BoxInc/Index";
import FailedEnteriesTable from "./Components/FailedEnteries/FailedEnteriesTable";
import { getFailedBatchesRequest } from "../BulkPayments/Redux/actions";


class FailedPaymentsEnteries extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openUploadDialog: false,
    };
  }
  componentWillMount() {

    this.getFailedEntries()

  }

  getFailedEntries(page, page_size){
    let guid = this.props.params.guid
    this.props.dispatch(getFailedBatchesRequest({
      page: page || 1,
      page_size: page_size || 10,
      batch_guid : guid
    }));
  }

  handlePageChange = (page, pageSize) => {
    this.getFailedEntries(page, pageSize)
  };

  toggleUploadDialog() {
    this.setState({ openUploadDialog: !this.state.openUploadDialog })
  }
  render() {
    const title = "Payment Enteries for Batch Number: "  + this.props.params.guid
    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <BoxInc
              expanded
              title={title}
              actionButtons={[]}

            >
              <FailedEnteriesTable
                failedEnteries={this.props.bulkPaymentsData.failedPaymentsBatches}
                loading={this.props.bulkPaymentsData.failedPaymentsBatchesLoader}
                onPageChange={this.handlePageChange}
              />
            </BoxInc>
          </Grid>
        </Grid>
      </>
    )
  }

}
export default connect((state) => ({
  bulkPaymentsData: state.bulkPayments,
  globalData: state.global,
}))(FailedPaymentsEnteries);
